if (!customElements.get('hide-description')) {
class HideDescription extends HTMLElement {
  constructor() {
    super();

    this.truncatedText = this.querySelector(".truncated-description");
    this.fullText = this.querySelector(".full-description");
    this.toggleButton = this.querySelector(".show-more");
  }

  connectedCallback() {
    this.toggleButton.addEventListener('click', this.handleToggle.bind(this));
  }

  handleToggle() {
    const isExpanded = this.toggleButton.getAttribute('aria-expanded') === 'true';

    if (isExpanded) {
      this.truncatedText.hidden = false;
      this.fullText.hidden = true;
      this.toggleButton.setAttribute('aria-expanded', 'false');
      this.toggleButton.textContent = this.toggleButton.dataset.showMore || 'Show more';
    } else {
      this.truncatedText.hidden = true;
      this.fullText.hidden = false;
      this.toggleButton.setAttribute('aria-expanded', 'true');
      this.toggleButton.textContent = this.toggleButton.dataset.showLess || 'Show less';
    }
  }
}

customElements.define('hide-description', HideDescription);

}